var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGraph = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2530_842)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.9143,
    cy: 19.3286,
    rx: 19.9143,
    ry: 19.3286,
    fill: "#367B6E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3059 5.85714C15.9707 5.85714 15.7144 6.12367 15.7144 6.47221V27.9998C15.7144 28.3483 15.9707 28.6149 16.3059 28.6149H19.2634C19.5986 28.6149 19.8549 28.3483 19.8549 27.9998C19.8549 27.6513 19.5986 27.3847 19.2634 27.3847H16.8974V7.08729H25.7701V12.623C25.7701 12.9715 26.0264 13.238 26.3616 13.238H31.6852V14.8782C31.6852 15.2268 31.9415 15.4933 32.2767 15.4933C32.6119 15.4933 32.8682 15.2268 32.8682 14.8782V12.623C32.8682 12.4589 32.809 12.3155 32.6907 12.1925L26.7756 6.04174C26.6573 5.91873 26.5193 5.85714 26.3616 5.85714H16.3059ZM26.9531 7.94823L30.8573 12.0079H26.9531V7.94823ZM32.2767 20.1472C31.9415 20.1472 31.6852 20.4137 31.6852 20.7623V31.0135C31.6852 31.362 31.9415 31.6286 32.2767 31.6286H35.0371C35.3723 31.6286 35.6286 31.362 35.6286 31.0135V20.7623C35.6286 20.4137 35.3723 20.1472 35.0371 20.1472H32.2767ZM32.8682 21.3773H34.4456V30.3984H32.8682V21.3773ZM27.1503 24.2477C26.8151 24.2477 26.5588 24.5142 26.5588 24.8628V31.0135C26.5588 31.362 26.8151 31.6286 27.1503 31.6286H29.9107C30.2459 31.6286 30.5022 31.362 30.5022 31.0135V24.8628C30.5022 24.5142 30.2459 24.2477 29.9107 24.2477H27.1503ZM27.7418 25.4778H29.3192V30.3984H27.7418V25.4778ZM22.221 27.3231C21.8858 27.3231 21.6295 27.5896 21.6295 27.9381V31.0135C21.6295 31.362 21.8858 31.6286 22.221 31.6286H24.9814C25.3166 31.6286 25.5729 31.362 25.5729 31.0135V27.9381C25.5729 27.5896 25.3166 27.3231 24.9814 27.3231H22.221ZM22.8125 28.5532H24.3899V30.3984H22.8125V28.5532Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2530_842",
    x: 0,
    y: 0,
    width: 47.8286,
    height: 46.6571,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2530_842"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2530_842",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGraph);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/graph.c81a71e305853f62fd996bf482cb9565.svg";